import { render } from "./flash.vue?vue&type=template&id=0dec384a"
import script from "./flash.js?vue&type=script&lang=js"
export * from "./flash.js?vue&type=script&lang=js"

import "./flash.vue?vue&type=style&index=0&id=0dec384a&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__